export default __webpack_public_path__ + "static/media/Product-Stock.9f5b5e2f.jpg";